import { ChallengeFormType, FormValidator } from '../../NewChallengeForm.types';

type Params = Pick<ChallengeFormType, 'authenticationMethod'>;

export const validate: FormValidator<Params> = ({ authenticationMethod }) => {
  if (typeof authenticationMethod !== 'string')
    return { isValid: false, message: '인증 방법을 확인해주세요' };
  return { isValid: true };
};
